import React, { useState, type FC } from 'react'

import { useIntl } from 'react-intl'

import {
  COLLAPSIBLE_TRIGGER_VARIANT_LIGHT,
  Collapsible,
  CollapsibleTrigger,
  Flex,
  LINK_VARIANT_EXTRALIGHT,
  Link,
  TEXT_VARIANT_SMALL_LIGHT,
  Text,
} from 'mailup-web-components'

import { notifyParent } from 'mailup-react-helpers'

interface TaskDetailsProps {
  sending: {
    Type?: 'Task' | 'Workflow' | undefined
    Id?: number
    Deleted?: boolean
    Name?: string
    StepOrder?: number
  }
}

const TaskDetails: FC<TaskDetailsProps> = ({ sending }) => {
  const intl = useIntl()
  const [collapsed, setCollapsed] = useState(true)

  const toggle = (): void => {
    setCollapsed((prev) => !prev)
  }

  const handleTaskClick = (): void => {
    if (sending.Id !== undefined) {
      notifyParent('redirectMainFrame', [
        `automation_app_redirector.aspx?r=/automation/task/${sending.Id}`,
      ])
    }
  }

  const handleWorkflowClick = (): void => {
    if (sending.Id !== undefined) {
      notifyParent('redirectMainFrame', [
        `automation_app_redirector.aspx?r=/automation/workflow/${sending.Id}/edit`,
      ])
    }
  }

  if (sending.Type === 'Task') {
    return (
      <div>
        <CollapsibleTrigger
          collapsed={collapsed}
          onChange={toggle}
          variant={COLLAPSIBLE_TRIGGER_VARIANT_LIGHT}
        >
          {intl.formatMessage({
            id: 'Load.ActiveRecipientSummary.TaskDetails',
          })}
        </CollapsibleTrigger>
        <Collapsible collapsed={collapsed}>
          <Flex flexDirection="column" padding="0 0 0 16px">
            <p>
              {intl.formatMessage({ id: 'Load.MailupCommon.Id' })} {sending.Id}
              {' - '}
              {sending.Deleted === true ? (
                sending.Name
              ) : (
                <Link
                  variant={LINK_VARIANT_EXTRALIGHT}
                  disabled={sending.Deleted}
                  onClick={handleTaskClick}
                >
                  {' '}
                  {sending.Name}
                </Link>
              )}
            </p>
            <Text variant={TEXT_VARIANT_SMALL_LIGHT} htmlElement="p">
              {intl.formatMessage({
                id: 'Load.ActiveRecipientSummary.TriggeredByTask',
              })}
            </Text>
          </Flex>
        </Collapsible>
      </div>
    )
  }

  if (sending.Type === 'Workflow') {
    return (
      <div>
        <CollapsibleTrigger
          collapsed={collapsed}
          onChange={toggle}
          variant={COLLAPSIBLE_TRIGGER_VARIANT_LIGHT}
        >
          {intl.formatMessage({
            id: 'Load.ActiveRecipientSummary.WorkflowDetails',
          })}
        </CollapsibleTrigger>
        <Collapsible collapsed={collapsed}>
          <Flex flexDirection="column" padding="0 0 0 16px">
            <p>
              {intl.formatMessage({ id: 'Load.MailupCommon.Id' })} {sending.Id}
              {' - '}
              {sending.Deleted === true ? (
                sending.Name
              ) : (
                <Link
                  variant={LINK_VARIANT_EXTRALIGHT}
                  disabled={sending.Deleted}
                  onClick={handleWorkflowClick}
                >
                  {' '}
                  {sending.Name}
                </Link>
              )}
            </p>
            <Text variant={TEXT_VARIANT_SMALL_LIGHT} htmlElement="p">
              {intl.formatMessage(
                {
                  id: 'Load.ActiveRecipientSummary.TriggeredByWorkflow',
                },
                {
                  0: sending.StepOrder,
                },
              )}
            </Text>
          </Flex>
        </Collapsible>
      </div>
    )
  }

  return null
}

export default TaskDetails
